var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notification-body"},[_c('article',{staticClass:"mt-1",domProps:{"innerHTML":_vm._s(_vm.localizedBody)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }